import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pureText',
})
export class PureTextPipe implements PipeTransform {
  transform(value: string, ...args: unknown[]): unknown {
    if (value) {
      return value
        .replace(/ class="[^"]*"/g, '') // Remove class attribute
        .replace(/ style="[^"]*"/g, ''); // Remove style attribute
    } else return null;
  }
}
